import * as Yup from "yup";

export const orderSchema = Yup.object().shape({
 trackingNumber: Yup.string()
  .nullable()
  .min(2, "Please enter at least 2 characters!")
  .max(50, "You can enter up to 50 characters!")
  .required("Tracking number is field required"),
});
